import ScrollReveal from './ScrollReveal';
import { Target, LineChart, Handshake, Zap } from 'lucide-react';

const WhyUsSection = () => {
  const differentiators = [
    {
      icon: Target,
      title: 'Focus sui Risultati',
      description: 'Non vanity metrics. Misuriamo solo ciò che impatta il tuo fatturato: lead qualificati, conversioni, ROI.',
    },
    {
      icon: LineChart,
      title: 'Data-Driven',
      description: 'Ogni decisione è basata sui dati. Dashboard in tempo reale, A/B testing continuo, ottimizzazione costante.',
    },
    {
      icon: Handshake,
      title: 'Partnership Vera',
      description: 'Non siamo fornitori, siamo partner. Il tuo successo è il nostro successo. Cresciamo insieme.',
    },
    {
      icon: Zap,
      title: 'Velocità di Esecuzione',
      description: 'Niente burocrazia. Team snello, decisioni rapide, implementazione veloce. Il mercato non aspetta.',
    },
  ];

  return (
    <section id="perche-noi" className="section-padding relative overflow-hidden bg-navy/30">
      <div className="container-premium">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left content */}
          <div>
            <ScrollReveal>
              <p className="text-gold tracking-[0.2em] uppercase text-sm mb-6">
                Perché sceglierci
              </p>
            </ScrollReveal>
            
            <ScrollReveal delay={0.1}>
              <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl mb-6 leading-tight">
                Non siamo l'agenzia giusta per tutti.
                <span className="text-gradient-gold"> E va bene così.</span>
              </h2>
            </ScrollReveal>
            
            <ScrollReveal delay={0.2}>
              <p className="text-lg text-muted-foreground mb-8">
                Lavoriamo solo con imprenditori ambiziosi che vogliono crescere davvero. 
                Se cerchi solo "visibilità" senza strategia, non siamo fatti l'uno per l'altro.
              </p>
            </ScrollReveal>

            <ScrollReveal delay={0.3}>
              <div className="flex flex-col sm:flex-row gap-4">
                <a href="/contatti" className="btn-premium">
                  <span>Inizia Ora</span>
                </a>
              </div>
            </ScrollReveal>
          </div>

          {/* Right grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {differentiators.map((item, index) => (
              <ScrollReveal 
                key={item.title}
                delay={0.1 * (index + 1)}
                direction="right"
              >
                <div className="glass-card-hover p-6 h-full">
                  <div className="w-12 h-12 rounded-xl bg-gold/10 flex items-center justify-center mb-4">
                    <item.icon className="w-6 h-6 text-gold" />
                  </div>
                  <h3 className="font-serif text-xl mb-3">{item.title}</h3>
                  <p className="text-sm text-muted-foreground">{item.description}</p>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUsSection;
